<template>
	<div class="referral">
		<v-contextual-content ref="contextual" :class="vContextualClass" class="v-contextual--referral">
			<template v-slot:trigger="{ toggle }">
				<button
					title="Referral" @click="toggle">Referral
				</button>
			</template>
			<template v-slot:default="{ toggle }">
				<header>
					<h1 class="beta heavy">Referral</h1>
				</header>
				<div class="v-contextual--referral__summary">
					<template v-if="!numberOfServices">
						<div class="nothing-to-see-here">
							<p>You have not started a referral.</p>
						</div>
						<ul class="actions">
							<li class="wide">
								<button
									v-if="$route.name !== 'services.index'"
									class="button button--primary--wide" @click.prevent="goToServices()">
									<span>Refer Services</span></button>
								<button
									v-else
									class="button button--primary--wide" @click.prevent="toggle()">
									<span>Refer Services</span></button>
							</li>
						</ul>
					</template>
					<template v-else>
						<dl>
							<dt>Services</dt>
							<dd
								class="beta"
								v-html="$present('ntext', '# Service', '# Services', numberOfServices)"/>
						</dl>
						<ul class="actions">
							<li class="wide">
								<router-link
									:to="{name: 'referrals.create'}"
									class="button button--primary--wide">Configure Referral</router-link>
							</li>
							<li class="wide">
								<process-button
									:processing="cancelling" class="button button--secondary--wide"
									text="Cancel Referral"
									@click.prevent="cancelReferral()">Cancel Referral
								</process-button>
							</li>
						</ul>
					</template>
				</div>
			</template>
		</v-contextual-content>
	</div>
</template>
<script>
export default {
	data() {
		return {
			cancelling: false,
		};
	},
	computed: {
		vContextualClass() {
			return {
				"v-contextual--referral--has-items": this.numberOfServices,
			};
		},
		numberOfServices() {
			return Object.keys(this.$authed().session.introduction || []).length;
		},
	},

	methods: {
		goToServices() {
			this.$router.push({name: "services.index"});
			this.refs.contextual.toggle();
		},
		completeReferral() {
			this.$router.push({name: "referrals.create"});
		},
		cancelReferral(service) {
			this.cancelling = true;
			http().delete(this.route("referral/cancel")).then(response => {
				this.eventBus.$handle("sessionReferralUpdated", response.data);
			}).finally(() => {
				this.cancelling = false;
			});
		},
	},
};
</script>
